import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

/**
 * @description
 * Hides when the paired `<predictive-search-results>` shows fetched hits
 * (`aria-hidden="false"`), same visibility contract as {@link PredictiveSearchResults}.
 */
class PredictiveSearchSuggestions extends HTMLElement {
  /** @type {HTMLElement | null} */
  #resultsEl = null;
  /** @type {MutationObserver | null} */
  #ariaObserver = null;
  #unsubscribers = [];
  #drawerId = this.closest('drawer-element')?.id;
  #searchId = this.dataset.searchId;

  connectedCallback() {
    if (this.#searchId) {
      this.#resultsEl = document.querySelector(
        `predictive-search-results[data-search-input-id="${CSS.escape(this.#searchId)}"]`
      );
    }

    this.#syncVisibilityFromResults();

    if (this.#resultsEl) {
      this.#ariaObserver = new MutationObserver(() => this.#syncVisibilityFromResults());
      this.#ariaObserver.observe(this.#resultsEl, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    }

    this.#unsubscribers.push(
      PubSub.subscribe('search:clear', ({ id }) => {
        if (id !== this.#searchId) return;
        queueMicrotask(() => this.#syncVisibilityFromResults());
      })
    );

    if (this.#drawerId) {
      this.#unsubscribers.push(
        PubSub.subscribe('drawer:open', ({ id }) => {
          if (id !== this.#drawerId) return;
          queueMicrotask(() => this.#syncVisibilityFromResults());
        })
      );
    }
  }

  disconnectedCallback() {
    this.#ariaObserver?.disconnect();
    this.#ariaObserver = null;
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
    this.#unsubscribers = [];
  }

  /** Mirrors whether predictive results are shown (not hidden for assistive tech / layout). */
  #syncVisibilityFromResults() {
    if (!this.#resultsEl) {
      this.ariaHidden = false;
      return;
    }
    const resultsShown = this.#resultsEl.getAttribute('aria-hidden') === 'false';
    this.ariaHidden = resultsShown;
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
